import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { FormInstance } from 'antd';
import { LifecycleStoreStage } from '@/store/Lifecycle/types';

interface StageContextValue {
    stage: LifecycleStoreStage;
    form?: FormInstance;
}

const StageContext = createContext<StageContextValue>(null);

export const useStage = () => {
    const context = useContext(StageContext);
    return context?.stage;
}

export const useStageForm = () => {
    const context = useContext(StageContext);
    return context?.form;
}

interface StageProviderProps {
    stage: LifecycleStoreStage;
    form?: FormInstance;
}

export const StageProvider = ({ stage, form, children }: PropsWithChildren<StageProviderProps>) => {
    const value = useMemo(() => ({ stage, form }), [stage, form]);
    
    return (
        <StageContext.Provider value={value}>
            {children}
        </StageContext.Provider>
    );
};